<template>
    <div class="homeContainer">
        <!-- <el-container> -->

            <div style="width:1000px;margin:30px auto">
                <el-input v-model="keyword" placeholder="请输入你要搜索的内容" @keydown.enter="search"></el-input>
                <div style="margin-top:20px">
                    <el-button type="primary" @click="add">添加</el-button>
                </div>
                <el-table :data="notes">
                    <el-table-column prop="song_name" label="歌曲名"></el-table-column>
                    <el-table-column prop="album_name" label="专辑名"></el-table-column>
                    <el-table-column prop="singer_name" label="歌手名"></el-table-column>
                    <el-table-column prop="type" label="类型"></el-table-column>
                    <el-table-column prop="note" label="笔记" width="300"></el-table-column>
                    <el-table-column label="编辑">
                        <template #default="scope">
                            <el-button @click="edit(scope.row)" type="primary" size="small">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog :visible.sync="showAdd">
                <el-form>
                    <el-form-item label="歌曲名">
                        <el-input v-model="form.song_name"></el-input>
                    </el-form-item>
                    <el-form-item label="专辑名">
                        <el-input v-model="form.album_name"></el-input>
                    </el-form-item>
                    <el-form-item label="歌手名">
                        <el-input v-model="form.singer_name"></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="form.type">
                            <el-option v-for="item in types" :key="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="笔记">
                        <el-input type="textarea" :rows="6" v-model="form.note"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="margin-top:20px" @click="submit" type="primary">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
<!--         </el-container> -->

    </div>
</template>

<script>
import { removeUserId, getUserId } from '../../utils/store.js'
import { updateMusicNote, getMyMusicNotes, searchMusicNote } from '../../api/assistant'
export default {
  data () {
    return {
      notes: [],
      keyword: '',
      form: {
        song_name: '',
        album_name: '',
        singer_name: '',
        type: '',
        note: ''
      },
      showAdd: false,
      id: '',
      types: ['整体', '歌词', '旋律', '段落', '独奏', '音色', '乐器', '采样', '和声', '和弦', '编曲', '混音', '节奏', '氛围']
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      getMyMusicNotes().then(res => {
        if (res.data.code === 0) {
          this.notes = res.data.data
        }
      })
    },
    edit (row) {
      this.id = row._id.$id
      this.form = JSON.parse(JSON.stringify(row))
      this.showAdd = true
    },
    add () {
      console.log('aaa')
      this.id = ''
      this.form = {
        song_name: '',
        album_name: '',
        singer_name: '',
        type: '',
        note: ''
      }
      this.showAdd = true
      console.log('bbb')
    },
    submit () {
      updateMusicNote(this.id, this.form.song_name, this.form.album_name, this.form.singer_name, this.form.type, this.form.note).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.fetchData()
          this.showAdd = false
        }
      })
    },
    formateDate (date) {
      const time = new Date(date * 1000)
      return `${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()}`
    },
    searchMusicNote () {
      searchMusicNote(this.keyword).then(res => {
        if (res.data.code === 0) {
          this.notes = res.data.data
        }
      })
    },
    logout () {
      removeUserId()
      location.reload()
    }
  }
}
</script>

<style scoped>
.el-header{
    background-color: #409EFF;
    color: #333;
    line-height: 60px;
    text-align: right;
}
.cardItem{
    width: 1000px;
    border-radius: 10px;
    border: 1px solid #DCDFE6;
    height: 400px;
    margin: 20px auto;
    text-align: left;
}
.title{
    margin-top:20px;
}
.content{
    margin-top:20px;
    height: 50%;
}
.label{
    margin-top:20px;
    margin-left:30px
}

.title .el-input__inner{
    padding-left:30px;
    border: none;
    font-size: 24px;
    font-weight: 600;
}

.content .el-textarea__inner{
    padding-left:30px;
    border: none;
    height: 200px;
    font-size: 16px;
    width: 970px;
    resize: none;
}

</style>
